<template>
  <div>
    <transition name="fade">
      <p
        v-show="!isLittleScroll"
        class="mb-1 label-12 all-ease-in-out"
        :class="{ 'transition-margin-top': isLittleScroll }"
      >
        Client
      </p>
    </transition>
    <b-dropdown
      ref="dropdownClients"
      aria-role="menu"
      expanded
      append-to-body
      :close-on-click="false"
      @active-change="handleClickDropdown"
    >
      <template #trigger>
        <div
          class="input-search-2 flex-center adjust-input-clients border-radius-5"
          :class="[classInput]"
        >
          <div class="vendor-filter-icon">
            <VendorFilter />
          </div>
          <b-input
            ref="inputClientsReadonly"
            :value="selectedClients"
            placeholder="Semua Client"
            class="input-none c-w-100 pr-4"
            readonly
          >
          </b-input>
          <div
            v-if="selectedClients !== 'Semua Client'"
            class="close-wrapper"
            @click="handleClearSearch"
          >
            <XMarkIcon size="10" color="#000" />
          </div>
        </div>
      </template>

      <div class="item-dropdown-client-wrapper">
        <div class="keyword-wrapper-dropdown">
          <b-input
            v-model="keywordClient"
            placeholder="Cari"
            class="input-search-2 input-none keyword-list-dropdown"
          ></b-input>
        </div>

        <ItemListDropdown
          :datas="mostSearched"
          title="Paling Sering Dicari"
          idItem="vendor_id"
          nameItem="vendor_name"
          logoItem="logo"
          class="mb-3"
          :keywordProps="keywordClient"
          @handleSelectData="handleSelectData"
        />

        <ItemListDropdown
          :datas="clients"
          title="Pilih Client"
          idItem="vendor_id"
          nameItem="vendor_name"
          logoItem="logo"
          :keywordProps="keywordClient"
          @handleSelectData="handleSelectData"
        />
      </div>
    </b-dropdown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { alertErrorMessage } from '@/helpers'

export default {
  name: 'DropdownClients',
  props: {
    isLittleScroll: {
      type: Boolean,
      default: false
    },
    classInput: {
      type: String,
      default: ''
    }
  },
  components: {
    XMarkIcon: () => import('@/components/icons/XMarkIcon'),
    VendorFilter: () => import('@/components/icons/VendorFilter.vue'),
    ItemListDropdown: () => import('./ItemListDropdown.vue')
  },
  data () {
    return {
      keywordClient: '',
      clients: [],
      mostSearched: []
    }
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl'
    }),
    selectedClients () {
      const mergedArray = [...this.clients, ...this.mostSearched].reduce((acc, item) => {
        acc.set(item.vendor_id, item)
        return acc
      }, new Map())
      const result = Array.from(mergedArray.values())

      if (result.filter((item) => item.selected).length < 1) return 'Semua Client'
      return result
        .filter((item) => item.selected)
        .map((item) => item.vendor_name)
        .join(', ')
    }
  },
  methods: {
    updateSelection (arrayName, props) {
      this[arrayName] = this[arrayName].map((item) =>
        item.vendor_id === props.vendor_id ? { ...item, selected: props.selected } : item
      )
    },
    handleClearSearch () {
      this.keywordClient = ''

      this.clients = this.clients.map((item) => ({
        ...item,
        selected: false,
        list_stores: item.list_stores.map((store) => ({ ...store, selected: false }))
      }))
      this.mostSearched = this.mostSearched.map((item) => ({
        ...item,
        selected: false,
        list_stores: item.list_stores.map((store) => ({ ...store, selected: false }))
      }))

      this.$store.commit('report/setSelectedClients', 'reset')

      let reset = false
      const isFiltered = JSON.parse(localStorage.getItem('report_clicked_filter'))
      if (isFiltered) {
        reset = true
      }
      this.$emit('selected', { data: '', type: 'clients', reset })
      if (this.$refs.dropdownClients.isActive) {
        this.$refs.dropdownClients.toggle()
      }
    },
    handleSelectData (props) {
      const dataSelected = props.selected
      this.$store.commit('report/setSelectedClients', dataSelected)

      if (this.clients.some((item) => item.vendor_id === dataSelected.vendor_id)) {
        this.updateSelection('clients', dataSelected)
      } else if (this.mostSearched.some((item) => item.vendor_id === dataSelected.vendor_id)) {
        this.updateSelection('mostSearched', dataSelected)
      }

      const mergedArray = [...this.clients, ...this.mostSearched].reduce((acc, item) => {
        acc.set(item.vendor_id, item)
        return acc
      }, new Map())
      const temp = Array.from(mergedArray.values())
      const result = temp
        .filter((item) => item.selected)
        .map((item) => item.vendor_id)
        .join(',')

      this.$emit('selected', { data: result, type: 'clients' })

      this.$nextTick(() => {
        const inputEl = this.$refs.inputClientsReadonly.$el.querySelector('input')
        inputEl.scrollLeft = inputEl.scrollWidth
      })
      localStorage.setItem('report_selected_clients', JSON.stringify({ dataSelected, result }))
    },
    getListClients () {
      const payload = {
        url: this.url
      }
      this.$store
        .dispatch('report/getListClients', payload)
        .then((response) => {
          const res = response.data.data
          const resMostSearched = res.most_searched
          const resClients = res.vendors

          const tempMostSearched = resMostSearched.map((obj) => obj.vendor_id)
          const result = resClients.filter((obj) => !tempMostSearched.includes(obj.vendor_id))
          if (result.length > 0) {
            this.clients = result.map((item) => ({
              ...item,
              selected: false,
              list_stores: item.list_stores.map((store) => ({ ...store, selected: false }))
            }))
          }
          if (resMostSearched.length > 0) {
            this.mostSearched = resMostSearched.map((item) => ({
              ...item,
              selected: false,
              list_stores: item.list_stores.map((store) => ({ ...store, selected: false }))
            }))
          }
        })
        .catch((error) => {
          alertErrorMessage(error)
        })
    },
    handlePageRefresh () {
      const temp = {
        clients: this.clients,
        mostSearched: this.mostSearched,
        keywordClient: this.keywordClient
      }
      localStorage.setItem('report_dropdown_clients', JSON.stringify(temp))
    },
    handleClickDropdown (value) {
      this.$emit('clickedDropdown', value)
    }
  },
  mounted () {
    const temp = localStorage.getItem('report_dropdown_clients')
    if (temp && JSON.parse(temp).clients.length > 0 && JSON.parse(temp).mostSearched.length > 0) {
      this.clients = JSON.parse(temp).clients
      this.mostSearched = JSON.parse(temp).mostSearched
      this.keywordClient = JSON.parse(temp).keywordClient

      const selected = localStorage.getItem('report_selected_clients')
      if (selected) {
        const dataSelected = selected && JSON.parse(selected).dataSelected
        const result = selected && JSON.parse(selected).result

        this.$store.commit('report/setSelectedClients', dataSelected)
        this.$emit('selected', { data: result, type: 'clients' })
      }
    } else {
      this.getListClients()
    }
  },
  created () {
    window.addEventListener('beforeunload', this.handlePageRefresh)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.handlePageRefresh)
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.adjust-input-clients {
  padding: 2.4px;
  padding-left: 20px;
  position: relative;
  width: 230px;
}

.vendor-filter-icon {
  position: absolute;
  left: 5px;
  top: 9.5px;
  z-index: 2;
}

.item-dropdown-client-wrapper {
  overflow: auto;
  max-height: 280px;
  position: relative;
}

.keyword-wrapper-dropdown {
  position: sticky;
  top: 1px;
  background: white;
  z-index: 3;
  padding-bottom: 5px;
}

.keyword-list-dropdown {
  border: 1px solid #e1e1e1;
  margin: 0 15px;
  margin-bottom: 5px;
}

.close-wrapper {
  position: absolute;
  right: -1px;
  top: 3px;
  padding: 5px 10px;
  cursor: pointer;
}
</style>
